function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAccountDetails = function SvgAccountDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.3 19.3H7.7c-1.4 0-2.5-1.1-2.5-2.5v-6.5c0-1.4 1.1-2.5 2.5-2.5h11.5c1.4 0 2.5 1.1 2.5 2.5v6.6c-.1 1.3-1.1 2.4-2.4 2.4M6.9 11v-.8c0-.5.4-.8.8-.8h11.5c.5 0 .8.4.8.8v.8zm0 1.7h13.2v4.1c0 .5-.4.8-.8.8H7.7c-.4 0-.8-.4-.8-.8zm.8 2.5c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8 0 .5-.4.8-.8.8H8.5c-.4 0-.8-.4-.8-.8",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgAccountDetails;